import * as React from "react";
import { ResponsiveContainer } from "recharts";

import { cn } from "../../lib/utils";

export type ChartConfig = {
  [k in string]: {
    label?: React.ReactNode;
    icon?: React.ComponentType;
  } & (
    | { color?: string; theme?: never }
    | { color?: never; theme: Record<string, string> }
  );
};

const ChartContext = React.createContext<{ config: ChartConfig } | null>(null);

interface ChartContainerProps extends React.ComponentProps<"div"> {
  config?: ChartConfig;
  children: React.ReactNode;
  /** Fixed dimensions avoid ResponsiveContainer resize/removeChild issues */
  width?: number;
  height?: number;
}

function ChartContainer({
  className,
  children,
  config = {},
  width,
  height,
  ...props
}: ChartContainerProps) {
  const hasFixedSize = width != null && height != null;
  return (
    <ChartContext.Provider value={{ config }}>
      <div
        data-slot="chart"
        className={cn(
          "[&_.recharts-cartesian-axis-tick_text]:fill-[var(--color-text-muted)] [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-[var(--color-border)] [&_.recharts-radial-bar-background-sector]:fill-[var(--color-panel)] [&_.recharts-layer]:outline-none [&_.recharts-sector]:outline-none [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-none flex justify-center items-center text-xs",
          className
        )}
        style={{ minHeight: 1, ...props.style }}
        {...props}
      >
        {hasFixedSize ? (
          <ResponsiveContainer width={width} height={height}>
            {children}
          </ResponsiveContainer>
        ) : (
          <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1}>
            {children}
          </ResponsiveContainer>
        )}
      </div>
    </ChartContext.Provider>
  );
}

export { ChartContainer };
